module.exports = __webpack_public_path__ + "static/media/16UNODC25.620a48ce.jpg";